import { taskReferenceParts, type TaskReference } from "@/lib/task-reference";

export function TaskReferenceDisplay({
  task,
  className = "",
  supportingText,
}: {
  task: TaskReference;
  className?: string;
  supportingText?: string;
}) {
  const { primary, secondary } = taskReferenceParts(task);
  return (
    <span className={`block min-w-0 ${className}`}>
      <span className="block break-words font-mono text-xs font-semibold">
        {primary}
      </span>
      <span className="block break-words font-mono text-[11px] text-muted-foreground">
        {secondary}
        {supportingText ? ` · ${supportingText}` : null}
      </span>
    </span>
  );
}
